import { BodyLG, BodyXL, Heading2XL, Heading3XL } from "../../../typography";

import { RiveAnimation } from "../../components/ui/RiveAnimation";

export const Card = () => {
  return (
    <>
      <div className="tw-mx-auto tw-hidden tw-max-h-[1164px] tw-w-full tw-max-w-[1448px] tw-flex-col tw-gap-x-[8.375em] tw-gap-y-[1em] tw-px-[142px] tw-py-[7.5em] min1040:tw-flex min1040:tw-flex-row">
        <div className="tw-flex tw-w-full tw-flex-col tw-items-end tw-justify-center tw-gap-y-[1em] min1040:tw-w-1/2">
          <div className="tw-flex tw-flex-col tw-gap-y-[1em]">
            <Heading3XL className="tw-my-0 tw-hidden min440:tw-flex">
              Why in-home care?
            </Heading3XL>

            <BodyXL className="tw-my-0 tw-hidden tw-text-gray-2 min440:tw-block">
              It costs nearly <span className="tw-font-bold">$12,000</span> for
              a patient to spend a single night at a hospital. Delivering care
              at home is often far less expensive and much more convenient for
              patients.
            </BodyXL>

            <BodyXL className="tw-my-0 tw-hidden tw-text-gray-2 min440:tw-block">
              But, robust infrastructure to enable this transition from the
              hospital to the home is missing. Instead, it's a patchwork of
              different vendors, tied together by faxes, phone calls and hours
              of time by nurses.
            </BodyXL>
          </div>
        </div>

        <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded-[2em] min440:tw-w-1/2">
          <RiveAnimation
            fallbackSrc="/landing_page_assets/about/About16.png"
            fallbackClassName="tw-h-fit tw-max-h-[430px] tw-w-full tw-max-w-[574px] tw-rounded-[2em]"
          />
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-[1em] tw-px-[1.25em] tw-py-[7.5em] min1040:tw-hidden">
        <Heading2XL className="tw-my-0 tw-text-center">
          Why in-home care?
        </Heading2XL>
        <RiveAnimation
          fallbackSrc="/landing_page_assets/about/About16.png"
          fallbackClassName="tw-h-fit tw-max-h-[430px] tw-w-full tw-max-w-[574px] tw-rounded-[2em]"
        />
        <BodyLG className="tw-my-0 tw-text-gray-2">
          It costs nearly <span className="tw-font-bold">$12,000</span> for a
          patient to spend a single night at a hospital. Delivering care at home
          is often far less expensive and much more convenient for patients.
        </BodyLG>
        <BodyLG className="tw-my-0 tw-text-gray-2">
          But, robust infrastructure to enable this transition from the hospital
          to the home is missing. Instead, it's a patchwork of different
          vendors, tied together by faxes, phone calls and hours of time by
          nurses.
        </BodyLG>
      </div>
    </>
  );
};
